/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Center_TitleInputs */

const en_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Top Center`)
};

const fr_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : En Haut au Centre`)
};

const de_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Oben Mitte`)
};

const it_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: Centro in alto`)
};

const ru_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Верхний центр`)
};

const es_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Centro superior`)
};

const zh_cn2_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：顶部中心`)
};

const ja_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置: 上部中央`)
};

const hi_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान: शीर्ष केंद्र`)
};

const pt_pt2_position_top_center_title = /** @type {(inputs: Position_Top_Center_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro Superior`)
};

/**
* | output |
* | --- |
* | "Position: Top Center" |
*
* @param {Position_Top_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_center_title = /** @type {((inputs?: Position_Top_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_top_center_title(inputs)
	if (locale === "de") return de_position_top_center_title(inputs)
	if (locale === "it") return it_position_top_center_title(inputs)
	if (locale === "ru") return ru_position_top_center_title(inputs)
	if (locale === "es") return es_position_top_center_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_top_center_title(inputs)
	if (locale === "ja") return ja_position_top_center_title(inputs)
	if (locale === "hi") return hi_position_top_center_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_top_center_title(inputs)
	return en_position_top_center_title(inputs)
});